import { IsNotEmpty, IsString, IsOptional, IsEmail, MaxLength } from 'class-validator';

export class CreateContactRequestDto {
    /**
     * Full name of the contact person
     * @example 'Jane Smith'
     */
    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    fullName: string;

    /**
     * Position or job title of the contact
     * @example 'Director, Quality and Regulatory (Canada)'
     */
    @IsOptional()
    @IsString()
    @MaxLength(255)
    positionTitle?: string;

    /**
     * Email address of the contact
     * @example 'jane.smith@acmepharma.com'
     */
    @IsOptional()
    @IsEmail()
    @MaxLength(255)
    email?: string;

    /**
     * Phone number of the contact
     * @example '+1 800 555 1234'
     */
    @IsOptional()
    @IsString()
    @MaxLength(50)
    phone?: string;
}
